<template>
  <div
    v-if="contact.active"
    class="contact-friend"
    :class="`contact-friend--${placement}`"
    @contextmenu.stop
    @copy.stop
    @selectstart.stop
  >
    <a
      class="contact-friend__link"
      :href="contact.url"
      target="_self"
      referrerpolicy="no-referrer"
    >加好友</a>
    <p class="contact-friend__hint">使用微信添加企业顾问</p>
    <div class="contact-friend__qr" data-testid="contact-qr">
      <img
        v-if="!qrFailed"
        class="contact-friend__qr-image"
        :src="contact.qrAssetPath"
        alt="微信扫码添加企业顾问"
        @error="qrFailed = true"
      >
      <p v-else class="contact-friend__qr-fallback">二维码加载失败，请使用上方“加好友”链接。</p>
      <p v-if="!qrFailed" class="contact-friend__qr-caption">使用微信扫码添加企业顾问</p>
    </div>
  </div>
</template>

<script>
import rawContactConfig from '@/config/contact.json';
import { validateContactConfig } from '@/contact/contactPolicy.mjs';

export default {
  name: 'ContactFriend',
  props: {
    placement: {
      type: String,
      default: 'hero',
      validator: (value) => ['hero', 'products', 'footer'].includes(value)
    }
  },
  data() {
    return {
      qrFailed: false
    }
  },
  computed: {
    contact() {
      return validateContactConfig(rawContactConfig);
    }
  }
}
</script>

<style scoped>
/* 布局与配色见 src/content/prerendered.css（随主样式一起打包）。 */
.contact-friend--hero {
  margin-top: 16px;
}
</style>
